import { useCallback } from 'react';
import { createColumnFilterRenderer } from '../../components/tables/createColumnFilterRenderer';
import { NotificationChannel } from '../../gql/generated';
import { useChannelFilters } from '../../hooks/useChannelFilters';

/**
 * Hook that returns a columnFilters render function for the DataTable.
 * Each column gets its corresponding filter component.
 * Reads/writes filter state directly from URL query params - no props needed.
 */
export function useChannelColumnFilters() {
  const { filters, setSearch } = useChannelFilters();

  const handleSearchChange = useCallback(
    (value: string) => {
      setSearch(value);
    },
    [setSearch]
  );

  return createColumnFilterRenderer<NotificationChannel>([
    {
      columnId: 'channelName',
      kind: 'search',
      value: filters.search,
      onChange: handleSearchChange,
      placeholder: 'Search channels...',
    },
  ]);
}
